export default __webpack_public_path__ + "82778973a0124e3630e2e7fe189d6e89.svg";